import { Tabs, TabList, Tab, Flex } from "@chakra-ui/react";

export default function CampaignTabs({ tabLabels, onChange, activeIndex = 0 }) {
  return (
    <Flex justify="space-between" align="center">
      <Tabs index={activeIndex} onChange={onChange} variant="unstyled">
        <TabList
          bg="gray.100"
          border="1px solid"
          borderColor="gray.200"
          borderRadius="8px"
          p={0}
          gap={0}
          display="inline-flex"
        >
          {tabLabels.map((label, idx) => (
            <Tab
              key={idx}
              fontFamily="Pretendard, sans-serif"
              fontWeight="700"
              fontSize="14px"
              color="#747F8C"
              bg="white"
              borderRight="1px solid"
              borderColor="gray.200"
              px="4"
              py="2.5"
              _first={{
                borderTopLeftRadius: "7px",
                borderBottomLeftRadius: "7px",
              }}
              _last={{
                borderTopRightRadius: "7px",
                borderBottomRightRadius: "7px",
                borderRight: "none",
              }}
              _selected={{
                bg: "#0054C0",
                color: "white",
                borderRightColor: "transparent",
                _hover: { bg: "#0047A3", color: "white" },
              }}
              _hover={{
                bg: "gray.200",
                color: "#747F8C",
              }}
              transition="all 0.2s ease"
            >
              {label}
            </Tab>
          ))}
        </TabList>
      </Tabs>
    </Flex>
  );
}
